import { Grid, Link, Typography, SxProps, Theme } from '@mui/material'
import { useTranslation } from 'react-i18next'

const FooterLinkStyle: SxProps<Theme> = {
  color: '#5B5C79',
  fontSize: { xs: '11px', lg: '12px' },
  textDecoration: 'underline',
  '&:hover': {
    color: '#4A4B68',
  },
}

const FooterGridItemStyle: SxProps<Theme> = {
  py: { xs: 0.75, lg: 0 },
  px: { xs: 0, lg: 2.5 },
}

export const Footer = () => {
  const { t } = useTranslation('general')
  return (
    <footer>
      <Grid
        container
        direction={{ xs: 'column', md: 'column', lg: 'row' }}
        sx={{
          justifyContent: 'center',
          alignItems: 'center',
          px: { xs: 2, md: 2, lg: 0 },
          py: { xs: 1, md: 1, lg: 0 },
          gap: { xs: 0.5, md: 0.5, lg: 2 },

          '@media (min-width: 1023px)': {
            flexDirection: 'row',
            flexWrap: 'nowrap',
            whiteSpace: 'nowrap',
            gap: 2,
            px: 0,
          },
        }}>
        <Grid sx={FooterGridItemStyle}>
          <Typography>
            <Link href="https://lawpilots.com/en/terms-of-service/" sx={FooterLinkStyle}>
              {t('footer_terms_and_conditions')}
            </Link>
          </Typography>
        </Grid>
        <Grid sx={FooterGridItemStyle}>
          <Typography>
            <Link href="https://lawpilots.com/en/data-protection/" sx={FooterLinkStyle}>
              {t('footer_privacy_policy')}
            </Link>
          </Typography>
        </Grid>
        <Grid sx={FooterGridItemStyle}>
          <Typography>
            <Link href="https://lawpilots.com/en/imprint/" sx={FooterLinkStyle}>
              {t('footer_imprint')}
            </Link>
          </Typography>
        </Grid>
      </Grid>
    </footer>
  )
}
